import styles from "components/event/EventDetailComponentLargeProductCardPrice.module.scss";
import Image from "next/image";
import TruncateMarkup from "react-truncate-markup";
import {numberWithComma} from "common/utils";
import addOptionCountsToPouch from "api/addToPouch";
import OptionSelectorModal from "components/modal/OptionSelectorModal";
import {useContext} from "react";
import ModalContext from "context/ModalContext";
import ToastContext from "context/ToastContext";
import PouchContext from "context/PouchContext";
import UserContext from "context/AuthContext";
import {toast} from "react-toastify";
import PouchIcon from "images/icons/add_to_pouch.svg";
import {getProductRoute} from "common/const";
import Link from "next/link";
import {useCouponDiscountedPrice} from "hooks/useCouponDiscountedPrice";


const EventDetailComponentLargeProductCardPrice = (props) => {
    const {product, productOption, description} = props;

    const {openModal, closeModal} = useContext(ModalContext) || {};
    const toastContext = useContext(ToastContext);
    const pouchContext = useContext(PouchContext);
    const user = useContext(UserContext).user;

    const handleCloseOptionSelectorModal = () => {
        closeModal();
    };

    const onAddToPouchSuccessOverride = () => {
        const toastId = toast.info(
            '장바구니에 제품을 담았어요',
        );
        toastContext.registerToast(toastId);
        closeModal();
    };

    const addToPouch = (e) => {
        e.stopPropagation();
        e.preventDefault();
        toastContext.closeToast();
        const options = product.options;
        if (options.length === 1) {

            const [referralId, referralPostId] = [null, null];
            const pouchOptions = [
                {
                    option_id: parseInt(options[0].id),
                    count: 1,
                    referral_id: referralId,
                    referral_post_id: referralPostId,
                    price: options[0].discounted_price
                }
            ];
            addOptionCountsToPouch(pouchOptions, user != null, onAddToPouchSuccessOverride, pouchContext,
                false, product.id, product.name);
        } else {
            openModal(() => {
                return <OptionSelectorModal
                    product={product} isModalOpen={true}
                    close={handleCloseOptionSelectorModal}
                    buttonText={"장바구니 담기"}
                    onAddToPouchSuccessOverride={onAddToPouchSuccessOverride}
                    isPouchForced
                />
            });
        }
    };

    const {discountedPriceText, discountRate} = useCouponDiscountedPrice(product, true);
    const finalPriceText = product.is_entered ? discountedPriceText : '미입점';

    return (
        <Link href={getProductRoute(product.id)}>
            <div className={styles.container}>
                <div className={styles.imageContainer}>
                    <Image layout="fill" unoptimized objectFit="cover" src={product.image_url}/>
                    <div className={styles.pouchButton} onClick={addToPouch}>
                        <PouchIcon width="32" height="32" viewBox="0 0 30 30"/>
                    </div>
                </div>
                <div className={styles.infoContainer}>
                    <TruncateMarkup maxLines={1} ellipsis={<span>...</span>}>
                        <div className={styles.productName}>
                            {product.name}
                        </div>
                    </TruncateMarkup>
                    <div>
                        <div className={styles.priceContainer}>
                            {
                                (!!product.discount_rate && discountRate > 0) &&
                                <span className={styles.discountRate}>{discountRate}%</span>
                            }
                            <span className={styles.price}>{discountedPriceText}</span>
                        </div>
                    </div>
                </div>
                {
                    description &&
                    <div className={styles.descriptionContainer}>
                        {
                            description && description.split('\n').map(
                                item => {
                                    return <div>{item}</div>
                                }
                            )
                        }
                    </div>
                }
            </div>
        </Link>
    );
}

export default EventDetailComponentLargeProductCardPrice;
